define('views/layouts/layout-overlay-stack',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'src/queue/delay-queue',
    // views
    'views/layouts/layout-overlay',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    DelayQueue,
    // views
    VLayoutOverlay
) {

    var VLayoutOverlayStack = Backbone.View.extend({
        className: 'overlay-stack open',
        overlay: VLayoutOverlay,
        constructor: function(opt) {
            this.queue = new DelayQueue({ delay: 200, context: this });

            VLayoutOverlayStack.__super__.constructor.apply(this, arguments);
        },

        _createOverlay: function(view, options) {
            var overlay = new this.overlay(_.extend({ view: view }, options));
            this.listenTo(overlay, {
                'back': this.onBack,
                'panel:stack': this.onStack
            });
            this.childViews.push(overlay);
            this.$el.append(overlay.render().el);
            return overlay;
        },

        push: function(view, open) {
            var overlay = this._createOverlay(view);
            if (open !== false) {
                _.defer(function() {
                    overlay.toggle(true);
                    view.onOpen(true);
                });
            }
            return this;
        },

        set: function(view, open) {
            return this.toggle(false).always(function() {
                this._set(view, open);
                this.toggle(open !== false);
                view.onOpen(open !== false);
            }.bind(this));
        },

        _set: function(view, open) {
            this.clear();
            var overlay = this._createOverlay(view);
            overlay.toggle(open);
        },

        is: function(view) {
            var overlay = this.childViews[0];
            return overlay && overlay.is(view);
        },

        isOpened: function() {
            return this.$el.hasClass('open');
        },

        toggle: function(val) {
            return this.queue.add(this._toggle, val, {
                condition: function() { return this.isOpened() !== val; }
            });
        },

        _toggle: function(val) {
            var $element = this.$el;
            setTimeout(function() {
                $element.toggleClass('open', val);
            }, 1);
        },

        clearOthers: function() {
            var arr = this.childViews;
            _.each(_.first(arr, arr.length - 1), function(view) {
                view.remove();
            });
        },

        clear: function() {
            this.removeChildViews();
        },

        ////////////
        // events //
        ////////////
        onBack: function(overlay) {
            if (this.childViews.indexOf(overlay) > 0) {
                overlay.close().done(function() {
                    overlay.remove();
                });
            } else {
                this.trigger('back');
            }
        },

        onStack: function(view) {
            this.push(view);
        },
    });

    return VLayoutOverlayStack;
});

